import { createContext } from "react";

const context = {
  basketId: "",
  setBasketId: () => {},
  basketCount: "",
  options: null,
  setBasketCount: () => {},
  basket: [],
  summary: null,
  setBasket: () => {},
  setSummary: () => {},
  address: null,
  userCountry: null,
  setAddress: () => {},
  setOptions: () => {},
};

const basketContext = createContext(context);

export default basketContext;
